import { LanguageResourceServiceDto } from "../../dtos/KioskDtos.dtos";
import { LanguageCodes } from "../../constants/languages";
import { LanguageResource } from "./LanguageResource";

export type LanguageLocaleResourceDictionary =  { [Key in LanguageCodes]: LanguageResource};

export class LanguageLocaleService {
    private currentLanguageResource: LanguageResource;
    private languageResources: LanguageLocaleResourceDictionary = {} as LanguageLocaleResourceDictionary;

    constructor(lang: LanguageResourceServiceDto) {
        this.languageResources[LanguageCodes.English] = new LanguageResource(lang.english);
        this.languageResources[LanguageCodes.French] = new LanguageResource(lang.french);
        this.languageResources[LanguageCodes.Spanish] = new LanguageResource(lang.spanish);
        this.currentLanguageResource = this.languageResources[LanguageCodes.English];
    }

    public getCurrentLanguageResource(): LanguageResource {
        return this.currentLanguageResource;
    }

    public setAndGetCurrentLanguageResource(languageCode: LanguageCodes): LanguageResource {
        this.currentLanguageResource = this.languageResources[languageCode];
        return this.currentLanguageResource;
    }
}



// WEBPACK FOOTER //
// ./src/services/Language/LanguageService.ts